import React from 'react';
import KomunikatI from '../../assets/GISwNauce_Komunikat_I_2026.pdf';
import Komunikat2 from '../../assets/GISwNauce_Komunikat_2_2026.pdf'
import Komunikat3 from '../../assets/GISwNauce_Komunikat_3_2026.pdf'
import './main.css';

const Main = () => {
  return (
    <div className="giswnauce__main">
      <span className="anchor-main" id="giswnauce_main"></span>
      <div className="giswnauce__main-content">
        <div className="content-description">
          <h1>XII Edycja Ogólnopolskiej Konferencji GIS w&nbsp;nauce</h1>
          <h2>Szanowni Państwo!</h2>

          <p>
            Serdecznie zapraszamy do udziału w&nbsp;XII edycji Ogólnopolskiej Konferencji <b>GIS w Nauce</b>, która odbędzie się w dniach <b>24-25 września 2026 roku</b> 
            &nbsp;na <b>Uniwersytecie Warmińsko-Mazurskim w Olsztynie</b>. Konferencja organizowana jest przez <b>Instytut Gospodarki Przestrzennej i Geografii</b>.&nbsp;<b>Wydarzenie zostało objęte</b> honorowym patronatem <b>JM Rektora Uniwersytetu Warmińsko-Mazurskiego w Olsztynie, dr. hab. Jerzego A. Przyborowskiego, prof. UWM,</b> 
            &nbsp;patronatem technologicznym <b>ESRI Polska</b> i patronatem medialnym <b>Radia UWM FM</b>. Wydarzenie jest współorganizowane przez <b>Polską Akademię Nauk</b>.
          </p>

          <p>
            Konferencja <i>GIS w Nauce</i> od lat stanowi istotne forum integrujące środowisko naukowe zajmujące się systemami informacji geograficznej, geoinformacją oraz geoinformatyką. Wydarzenie skupia przedstawicieli różnych dyscyplin naukowych, umożliwiając wymianę idei, doświadczeń oraz wyników badań związanych z zastosowaniem GIS w naukach ścisłych, przyrodniczych, technicznych i humanistycznych.
            Pierwsza konferencja <i>GIS w Nauce</i>, zainicjowana w <b>2012</b> roku przez <b>prof. Iwonę Jażdżewską oraz prof. Jacka Urbańskiego</b>, odbyła się na Uniwersytecie Łódzkim. Od tego czasu wydarzenie cieszy się nieustannie rosnącym zainteresowaniem środowiska naukowego. Do udziału zapraszamy zarówno doświadczonych badaczy, jak i młodych naukowców rozpoczynających swoją działalność naukową.
          </p>
          

          <p>
            Głównym celem konferencji jest prezentacja najnowszych osiągnięć naukowych w obszarze systemów informacji geograficznej oraz stworzenie przestrzeni do merytorycznej dyskusji nad szerokim spektrum ich zastosowań badawczych i praktycznych. Wydarzenie stanowi również doskonałą okazję do spotkania przedstawicieli środowiska naukowego, wymiany poglądów oraz nawiązania nowych form współpracy.
          </p>

          <p>
            Tegoroczna edycja, kontynuując wieloletnią tradycję konferencji, po raz drugi odbędzie się w Olsztynie – mieście akademickim o silnych tradycjach naukowych i dynamicznie rozwijającym się zapleczu badawczym.
            Program konferencji obejmuje <b>m.in. sztuczną inteligencję i nowe narzędzia GIS, teledetekcję, monitoring środowiska, planowanie przestrzenne, analizę konfliktów przestrzennych, dostępność i mobilność oraz zastosowania GIS w badaniach dziedzictwa i przestrzeni lokalnej</b>. 
            Szczególne miejsce zajmą zagadnienia związane z AI, automatyzacją analiz przestrzennych i wspomaganiem decyzji, które pokazują kierunki rozwoju współczesnego GIS-u. Konferencję zwieńczy panel dyskusyjny „<b>GIS i rynek pracy – czego pracodawcy oczekują od absolwentów?</b>”, łączący perspektywę naukową z praktycznymi potrzebami rynku pracy.
          </p>

          <a href={ KomunikatI } target="_blank" rel="noreferrer"><h3>
          KOMUNIKAT I
          </h3></a>

          <a href={ Komunikat2 } target="_blank" rel="noreferrer"><h3>
          KOMUNIKAT II
          </h3></a>

          <a href={ Komunikat3 } target="_blank" rel="noreferrer"><h3>
          KOMUNIKAT III
          </h3></a>
        </div>
      </div>
    </div>
  )
}

export default Main